import { render, staticRenderFns } from "./VincularSelos.vue?vue&type=template&id=0fa6c935&scoped=true&"
import script from "./VincularSelos.vue?vue&type=script&lang=js&"
export * from "./VincularSelos.vue?vue&type=script&lang=js&"
import style0 from "./VincularSelos.vue?vue&type=style&index=0&id=0fa6c935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6c935",
  null
  
)

export default component.exports